import { getAPIPath, requestCamerasGooseAPI } from '../shared/request'
import { ClientLocationCamerasList, ClientLocationCamerasConfig } from '../types/cameras-api'
import { CLIENT_CAMERAS_LIST_PATH, CLIENT_CAMERAS_ACCESS_PATH } from '../types/constants'

export interface TClientLocationPetProfileService {
  getCamerasList: (locationName: string, lupId: string) => Promise<ClientLocationCamerasList>
  getCamerasAccess: (locationName: string, lupId: string) => Promise<ClientLocationCamerasConfig>
}

export const ClientLocationCamerasService: TClientLocationPetProfileService = {
  getCamerasList: (locationName: string, lupId: string) =>
    requestCamerasGooseAPI<ClientLocationCamerasList>({
      url: getAPIPath(CLIENT_CAMERAS_LIST_PATH, { locationId: locationName, lupId }),
      method: 'GET',
    }),

  getCamerasAccess: (locationName: string, lupId: string) =>
    requestCamerasGooseAPI<ClientLocationCamerasConfig>({
      url: getAPIPath(CLIENT_CAMERAS_ACCESS_PATH, { locationId: locationName, lupId }),
      method: 'GET',
    }),
}
